// extracted by mini-css-extract-plugin
module.exports = {"modalBtn":"styles_modalBtn__28KLq","file":"styles_file__1MElb"};